import type { TargetEnvironment } from '@ms-cloudpack/common-types';
import type { PartialContext } from '../types/Context.js';
import { getBundleLocation } from './getBundleLocation.js';

export async function getRemoteCachePackageId(
  options: { packagePath: string; targetEnvironment: TargetEnvironment },
  context: PartialContext<'packageHashes' | 'packages', 'cachePath'>,
): Promise<string> {
  const { folderName } = await getBundleLocation(
    {
      ...options,
      hash: await context.packageHashes.get({
        ...options,
        // Source hashing is only enabled for internal packages in the PackageHashes, we do not need to check here.
        isSourceHashingEnabled: true,
      }),
    },
    context,
  );

  return folderName;
}
